import { COLORS } from '@btime/constants'
import React from 'react'

import { ControledErrorMessage } from '../../../components/helpers/ErrorHandler'
import { Title } from '../../../components/presentation/Text'
import ChecklistLoader from './_load/ChecklistLoader'
import ChecklistPreview from './ChecklistPreview'
import ControlledModal from '../../../components/modals/ControlledModal'
import Separator from '../../../components/helpers/Separator'
import ImperativeComponents from '../../../containers/dynamic/form/replies/context/ImperativeComponentsContext'

const PreviewModal = props => {
  return (
    <ControlledModal width="54rem" bgColor={COLORS.light1} {...props}>
      <ChecklistLoader>
        <ControledErrorMessage message="Essa é uma funcionalidade experimental. Estamos trabalhando para deixa-la mais estável.">
          <Title size="h5" align="center" noMargin>
            Simulação do Questionário
          </Title>
          <Separator weight={4} />
          <ImperativeComponents>
            <ChecklistPreview />
          </ImperativeComponents>
        </ControledErrorMessage>
      </ChecklistLoader>
    </ControlledModal>
  )
}

export default PreviewModal
